module.exports = __webpack_public_path__ + "img/help_title.05eaa13c.png";